import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { message } from "antd";
import Instance from "../../AxiosConfig";
import { Spin } from "antd";
const AddManagerModal = ({ show, handleClose, fetchData }) => {
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [target, setTarget] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // const [role, setRole] = useState("MANAGER");
  const handleSave = async () => {
    setSubmitted(true);
    try {
      if (!name || !email) {
        message.error("Please fill in all required fields");
        return;
      }

      setLoading(true);
      // const token = localStorage.getItem("token");

      const response = await Instance.post("/agents", {
        agentName: name,
        agentEmail: email,
        agentNumber: mobileNumber,
        role: "MANAGER",
      });
      console.log(response);

      if (response.status == 200 || response.status == 201) {
        message.open({
          type: "success",
          content: "New Manager added successfully!",
          className: "custom-add-agent-toast",
        });
        handleClose();
        setName("");
        setEmail("");
        setMobileNumber("");
        setSubmitted(false);
        fetchData();
      }
    } catch (error) {
      console.error("Add agent error:", error?.response?.data);

      const errorData = error?.response?.data;

      if (error?.response?.status === 409) {
        if (errorData?.duplicateType === "EMAIL") {
          message.error(
            `Email already exists for ${errorData?.conflictingAgent?.agentName}`,
          );
        } else if (errorData?.duplicateType === "NUMBER") {
          message.error(
            `Mobile number already exists for ${errorData?.conflictingAgent?.agentName}`,
          );
        } else {
          message.error(errorData?.message);
        }

        return;
      }

      message.error("Failed to add agent");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="custom-agent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Manager</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Manager Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={`form-control ${
                    submitted && !name ? "input-error" : ""
                  }`}
                  placeholder="Enter Manager name"
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Manager Email <span className="required">*</span>
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`form-control ${
                    submitted && !email ? "input-error" : ""
                  }`}
                  placeholder="Enter email"
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Manager Mobile Number <span className="required">*</span>
                </label>
                <input
                  type="tel"
                  value={mobileNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    if (value.length <= 10) {
                      setMobileNumber(value);
                    }
                  }}
                  className={`form-control ${
                    submitted &&
                    (!mobileNumber || !/^\d{10}$/.test(mobileNumber))
                      ? "input-error"
                      : ""
                  }`}
                  placeholder="Enter 10-digit mobile number"
                />
              </div>

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="users-discard-button"
                  onClick={handleClose}
                >
                  Discard
                </button>
                <button
                  type="button"
                  className="users-save-button d-flex align-items-center justify-content-center"
                  onClick={handleSave}
                  disabled={loading} // disable when loading
                  style={{ minWidth: "100px" }}
                >
                  {loading ? (
                    <>
                      <Spin size="small" /> &nbsp;Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddManagerModal;
